<div class="back-arrow-container">
  <mat-icon class="back-arrow-icon text-dark" (click)="goBack()" [matTooltip]="matIconToolTip">{{ matIconName }}</mat-icon>
</div>
